import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc, getDocs, deleteDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyB5srVb6rC46Eqcx9KBgiO3UV_s5HGYhes",
  authDomain: "shyeecodes-fe445.firebaseapp.com",
  projectId: "shyeecodes-fe445",
  storageBucket: "shyeecodes-fe445.firebasestorage.app",
  messagingSenderId: "91695389174",
  appId: "1:91695389174:web:763a106e3232b18e330fd7",
  measurementId: "G-H3FQ6NRDG7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);
const storage = getStorage(app);

export { db, storage, collection, addDoc, getDocs, deleteDoc, doc, updateDoc, ref, uploadBytes, getDownloadURL };
